
import React from 'react'
import { message } from 'antd';
import Config from '../../config/Config';
import WidgetAjax from '../../widget/WidgetAjax';
import NoData from '../com/NoData/index'
let path = Config.getBasePath();
let application = Config.getApplication();
class appraisal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [
        { name: '人格测评', num: '2', tag: ['大五人格测试', '责任心测试', '大五人格测试', '责任心测试', '大五人格测试', '责任心测试', '大五人格测试', '责任心测试'] },
        { name: '职业能力', num: '1', tag: ['职业价值观测试'] }
      ]
    }

  }

  componentDidMount() {

  }






  unbind = () => {
    const { user_info } = this.state;

    const onUnBind = (res) => {
      if (res.status == 0) {
        message.success("解绑成功!");
        this.refresh();
      } else {
        message.error("解绑失败!")
      }
    }
    WidgetAjax.ajax({ url: path + "/weixin/unbind", params: { UID: user_info.UID, application }, callback: onUnBind });

  }


  toTest = () => {
    this.props.history.push({ pathname: '/home/career-planning' })
  }

  AnalysisDetails = () => {
    this.props.history.push({ pathname: '/home/testReport' })
  }


  render() {
    const { data } = this.state;

    return <div>


      <div className='controlPanel'>
        <span className='basic_Title'>我的测评</span>

        <div className='appraisal_box'>
          <div className='appraisal_tips'>根据您目前的测试结果为您分析以下项目，点击<a onClick={this.toTest}>高亮题目</a>查看报告结果！</div>
          <div className='appraisal_tips'>进行更多测试得到结果更准确！【<a onClick={this.toTest}>去测试</a>】</div>
          <div className='appraisal_list'>
            {
              data && data.length > 0 ?
                data.map((item) => {
                  return <div className='appraisal_item'>

                    <div className='appraisal_head'>
                      <div className='appraisal_logo'> <img src={require("../../img/pinzhunzhun/dataSource/appraisal_logo.png")} /> </div>
                      {item?.name} <a>2</a> 个
                    </div>
                    <div className='appraisal_tag'>
                      {
                        item && item?.tag.length > 0 ?
                          item?.tag.map((item,index) => {
                            return <div className= {index == 1 ? 'appraisal_tag_item checked' :'appraisal_tag_item'} 
                            onClick={index == 1 ?()=>{this.AnalysisDetails()}:()=>{}}
                            >{item} </div>
                          })
                          : null
                      }
                    </div>

                  </div>
                })
                : <NoData />
            }
          </div>
        </div>
      </div>





    </div>
  }
}

export default appraisal;